import { ActionContext, ActionTree } from 'vuex'
import { RootState } from '@/Infrastructure/Store/RootState'
import { AuctionState } from './AuctionState'
import { NotificationData } from './NotificationData'
import { PersonalData } from './PersonalData'
import { RepresentationData } from './RepresentationData'
import { StatementsData } from './StatementsData'
import { DocumentationsData } from './DocumentationsData'
import { VerificationData } from './VerificationData'
import { ResforDataDto } from '@/Application/Resfor'

export const actions: ActionTree<AuctionState, RootState> = {
  clearAuction: (context: ActionContext<AuctionState, RootState>) => {
    context.commit('clearAuction')
  },
  setNotification: (context: ActionContext<AuctionState, RootState>, payload: NotificationData) => {
    context.commit('setNotification', payload)
  },
  setPersonalData: (context: ActionContext<AuctionState, RootState>, payload: PersonalData) => {
    context.commit('setPersonalData', payload)
  },
  setRepresentationData: (context: ActionContext<AuctionState, RootState>, payload: RepresentationData) => {
    context.commit('setRepresentationData', payload)
  },
  setResforCode: (context: ActionContext<AuctionState, RootState>, payload: string) => {
    context.commit('setResforCode', payload)
  },
  setResforNif: (context: ActionContext<AuctionState, RootState>, payload: string) => {
    context.commit('setResforNif', payload)
  },
  setProcedureData: (context: ActionContext<AuctionState, RootState>, payload: string[]) => {
    context.commit('setProcedureData', payload)
  },
  setLastWizardStep: (context: ActionContext<AuctionState, RootState>, payload: number) => {
    context.commit('setLastWizardStep', payload)
  },
  setProcesedAuctionA: (context: ActionContext<AuctionState, RootState>, payload: boolean) => {
    context.commit('setProcesedAuctionA', payload)
  },
  setStatementsData: (context: ActionContext<AuctionState, RootState>, payload: StatementsData) => {
    context.commit('setStatementsData', payload)
  },
  setDocOptionSelected: (context: ActionContext<AuctionState, RootState>, payload: number) => {
    context.commit('setDocOptionSelected', payload)
  },
  clearDocumentationsData: (context: ActionContext<AuctionState, RootState>) => {
    context.commit('clearDocumentationsData')
  },
  setDocumentations: (context: ActionContext<AuctionState, RootState>, payload: DocumentationsData[]) => {
    context.commit('setDocumentations', payload)
  },
  setVerifications: (context: ActionContext<AuctionState, RootState>, payload: VerificationData[]) => {
    context.commit('setVerifications', payload)
  },
  updatePersonalDataWithResforData: (context: ActionContext<AuctionState, RootState>, payload: ResforDataDto) => {
    context.commit('updatePersonalDataWithResforData', payload)
  }
}
